// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__310Mt","content":"styles_content__9uwg4"};